import { useContext, useEffect } from "react";
import Layout from "@wrappers/layouts/main-layout/Layout";
import { useClearGridData, useGetModulesData } from "@hooks/AllCustomHooks";
import BudgetRecommendations from "./BudgetRecommendations";
import { createDatasource } from "@ts/retrieve-data";
import {
    agBtnExport,
    setPillBadges,
    resetPillBadges,
    getActiveModule,
} from "@ts/utils";
import { getDateObj } from "@ts/date-range";
import { mainContext } from "@ts/constants";
import { useSelector, useDispatch } from "react-redux";
import { updateTitle } from "@features/titleSlice";
import { updateActiveTab } from "@features/activeTabSlice";
import { updateActiveModule } from "@features/activeModuleSlice";
import { setIsLoader } from "@features/loaderSlice";
import {
    IChannel,
    IMainContext,
    Keyword,
    SubModule,
    TActiveClientId,
    TCommonRowData,
} from "@ts/common-types";
import TabsComponent from "@components/tabs/TabsComponent";
import {
    setBudgetRecommendationData,
    setPlacementRecommendationData,
} from "@features/gridDataSlice";
import { useLocation } from "react-router-dom";

const CampaignsRecommendations = () => {
    const {
        dates,
        DateRange,
        setBudgetRecommendationsLoading,
        setPlacementRecommendationsLoading,
        budgetRecommendationsGridApi,
        placementRecommendationsGridApi,
    } = useContext<IMainContext>(mainContext);
    const clearGridData = useClearGridData();
    const channel = useSelector((state: IChannel) => state.channel.value);
    const activeClientId = useSelector(
        (state: TActiveClientId) => state.activeClientId.value
    );
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const loaderCount = useGetModulesData({ type: "loader-count" });

    let loader = 0;

    const incrementLoader = () => {
        loader = loader + 1;
        if (loader === loaderCount) {
            dispatch(setIsLoader(false));
        }
    };

    const activeModule = getActiveModule().activeModule;

    const onBtnExport = () => {
        if (activeModule === SubModule.CAMPAIGN_BUDGET) {
            agBtnExport(budgetRecommendationsGridApi);
        } else if (activeModule === SubModule.CAMPAIGN_PLACEMENT) {
            agBtnExport(placementRecommendationsGridApi);
        }
    };

    const populateBudgetData = async () => {
        return await createDatasource("campaign-budget-recommendation", {
            dateObj: getDateObj(),
        });
    };

    const populatePlacementData = async () => {
        return await createDatasource("campaign-placement-recommendation", {
            dateObj: getDateObj(),
        });
    };

    useEffect(() => {
        clearGridData();
        dispatch(updateTitle("Campaigns"));
        dispatch(updateActiveTab("campaign-budget-recommendation"));
        dispatch(updateActiveModule("campaign-budget-recommendation"));
        dispatch(setIsLoader(true));
        setBudgetRecommendationsLoading(true);
        setPlacementRecommendationsLoading(true);
        dispatch(setBudgetRecommendationData(null));
        dispatch(setPlacementRecommendationData(null));
        // eslint-disable-next-line
        loader = 0;
        resetPillBadges();

        populatePlacementData().then((placement) => {
            if (placement) {
                setPillBadges(
                    "placement-badge",
                    (placement as TCommonRowData).length
                );
                dispatch(
                    setPlacementRecommendationData(placement as Array<Keyword>)
                );
                setPlacementRecommendationsLoading(false);
                incrementLoader();
            }
        });

        populateBudgetData().then((budget) => {
            if (budget) {
                setPillBadges(
                    "budget-badge",
                    (budget as TCommonRowData).length
                );
                dispatch(setBudgetRecommendationData(budget as Array<Keyword>));
                setBudgetRecommendationsLoading(false);
                incrementLoader();
            }
        });
    }, [activeClientId, dates, DateRange, dispatch, channel]);

    return (
        <>
            <Layout>
                <div className="main-content-body subheader-fixed">
                    <div className="tabbable-line">
                        <TabsComponent onBtnExport={onBtnExport} />
                        {pathname === "/campaign-recommendations" && (
                            <BudgetRecommendations />
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default CampaignsRecommendations;
